// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';
import { Favorecido } from './favorecido.model';

export class FavorecidoPrestador extends BaseResourceModel {
    constructor(
        public id?: number,
        public prestador?: Favorecido,
        public favorecido?: Favorecido,
        public editavel?: boolean,
        public orgao?: Orgao
    ) {
        super();
    }
    static converteJson(json: any): FavorecidoPrestador {
        return Object.assign(new FavorecidoPrestador(), json);
    }
}
